// CONSTANTS are all caps.
const NS = 'SmartSearch';
const CLS = 'smartSearch';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/smartSearch.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class SmartSearch {
	constructor($el) {
		// $el is the widget node return by the loadSmartSearch function
		this.$el = $el;
	}

	init() {
		this.setSmartSearch();
	}

	setSmartSearch() {
		// Add Some logic here
		const $wg = $(this.$el);
		let ssToggle = $('.smartSearch-toggle');
		let siteHeaderToggle = $('.siteHeader-searchToggle'); // if it's in the header
		let $predectiveSearchEndpointApi = $wg.data('predectivesearchendpointapi');
		let $searchPageUrl = $wg.data('searchpageurl');
		let $resultsHolder = $wg.find('.predictiveSearchHolder .results-holder');
		let $searchField = $wg.find('.smart-search-field');

		ssToggle.on('click', (e) => {
			$wg.toggleClass('is-open');
			siteHeaderToggle.toggleClass('is-open'); // if it's in the header
			if ($wg.hasClass('is-open')) {
				$wg.find('.smart-search-field').trigger('focus');
			} else {
				$searchField.val('');
				$resultsHolder.fadeOut(0);
				$resultsHolder.empty();
			}
		});

		// fetch results for predective search from api
		// if user types a min of 3 letters
		$searchField.on('input keypress', function(e) {
			let $value = $(this).val();
			if (($value.length >= 3)) {
				delay(function() {
					$wg.find('.icon-spinner').addClass('is-active');
					$resultsHolder.empty();
					let $fetchUrl = $predectiveSearchEndpointApi + '?term=' + encodeURIComponent($value);
					// pass value in here (in the empty string) as $value
					// dummy mock api now only accept 1 as a search string
					fetch($fetchUrl, {
						method: 'get',
						credentials: 'same-origin',
					})
					.then((resp) => resp.json())
					.then(function(data) {
						if (data.result == 'SUCCESS') {
							// clear append the list
							for (let i = 0; i < data.response.length; i++) {
								$resultsHolder.fadeIn(0);
								$resultsHolder.append('<a href="' + data.response[i].url + '">' + data.response[i].title + '</a>');
							}
							if (data.response.length == 0) {
								$resultsHolder.fadeOut(0);
								$resultsHolder.empty();
							}
							$wg.find('.icon-spinner').removeClass('is-active');
						}
					})
					.catch(function(msg) {
						// error msg
						$wg.find('.icon-spinner').removeClass('is-active');
						$resultsHolder.fadeOut(0);
						$resultsHolder.empty();
					});
				}, 500);
			}
		});

		// detect enter clicks and redirect to search page
		$searchField.on('keyup', function(e) {
			let $key = e.keyCode;
			// enter key == 13
			if ($key == 13) {
				let $value = $searchField.val();
				// pass value onto the url if value isn't empty
				if ($value && $value != '') {
					window.location.replace($searchPageUrl + '#?term=' + $value);

					if (window.location.href.indexOf($searchPageUrl) !== -1) {
						window.location.reload();
					}
				}
			}
		});

		// delay execution of function
		let delay = (function() {
			let timer = 0;
			return function(callback, ms) {
				clearTimeout(timer);
				timer = setTimeout(callback, ms);
			};
		})();
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/widgets/smartSearch/js/smartSearch.js